import axios from 'axios';

export const GET_INFO = 'GET_INFO';

export function getInfo(){
	const request = axios.get('https://jsonplaceholder.typicode.com/users');

	return {
		type: GET_INFO,
		payload: request

	} // END return

} // END export


// WEBPACK FOOTER //
// ./src/redux/actions/testActions.js